import React, { useEffect, useState } from "react";
import Ball from "../../Ball/Ball";
import { useGameStateStore } from "../../../stores/gameStateStore";
import "./LastBallsCon.css";


export default function LastBallsCon() {
  const pickedNumbers = useGameStateStore(s => s.pickedNumbers);
  const lastThree = pickedNumbers.slice(-3).reverse();

  return (
    <div className="last-balls-con">
      {
        lastThree.map((number, nI) => <BigBall
          number={number}
          index={nI}
          key={`big-ball-${nI}`}
        />)
      }
    </div>
  )
}


type BigBallProps = {
  number: number;
  index: number;
};

function BigBall({ number, index }: BigBallProps) {
  const [animate, setAnimate] = useState(false);
  const list = ["first", "second", "third"];

  useEffect(() => {
    // Top değiştiğinde animasyonu tetiklemek için sıfırla
    setAnimate(false);
    const timeout = setTimeout(() => {
      setAnimate(true);
    }, 30);

    return () => clearTimeout(timeout);
  }, [number]); // number değiştiğinde yeniden animasyon başlat

  return (
    <div
      key={`${number}-${index}`}
      className={`big-ball-wrapper ${list[index]}-ball-start ${animate ? `${list[index]}-ball-end` : ""}`}
    >
      <Ball number={number} className="normal-ball" numberClassName="normal-ball-number" />
    </div>
  );
}